<div
    (click)="process(style?.link)"
    [ngClass]="{ 'disabled-link': style.active }"
    fxLayout="column"
    fxLayoutAlign="center center"
    style="position: relative"
    [ngStyle]="{ marginBottom: margin + 'px' }"
>
    <a
        class="anchor-tag"
        [routerLink]="[style?.link | pageIdFromLink]"
        [queryParams]="style?.link | queryParamFromLink"
        [ngClass]="{ 'img-error': !imageLoaded }"
    >
        <img
            (error)="missingImage($event)"
            [src]="style?.image"
            [class]="imageCSSClasses"
            appImageCDN
        />
    </a>
    <div
        [fxShow]="style.active"
        [class]="imageActiveBorderClass"
        class="style-item-image-active-border"
    ></div>
    <a
        *ngIf="!hideTitle"
        class="anchor-tag"
        [routerLink]="[style?.link | pageIdFromLink]"
        [queryParams]="style?.link | queryParamFromLink"
    >
        <p [class]="textCSSClasses" [ngStyle]="{ color: style?.title?.color }">
            {{ style?.title?.text }}
        </p>
    </a>
</div>
